import * as React from 'react';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { ChangeEvent } from 'react';
import './Login.css';
import ApplicationState from '../../application/core/State';
import logo from '../img/HappySocks-Logo-45px.svg';
import { passwordRegex } from './regexPatterns';
import UserChangePasswordRequested from '../../application/user/events/UserChangePasswordRequested';
import background from '../img/SS19-HappySocks-Showroom-Background-1600x500.png';

interface State {
    password: string;
    confirmPassword: string;
    passwordErrorMessage: string;
}

interface StateProps {
    errorMessage: string;
}

class ChangePassword extends React.PureComponent<DispatchProps & StateProps, State> {
    constructor(props: DispatchProps & StateProps) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            passwordErrorMessage: ''
        };
    }

    public render(): JSX.Element {
        return (
            <div>
                <div className="login">
                    <div className="login-form">
                        <h1>Enter your new password</h1>
                        <label htmlFor="password">Password:</label>
                        <input name="password" type="password" onChange={this.passwordChanged} />
                        <label htmlFor="confirmPassword">Confirm password:</label>
                        <input name="confirmPassword" type="password" onChange={this.confirmPasswordChanged} />
                        {this.state.passwordErrorMessage && <span className="login-error-message">{this.state.passwordErrorMessage}</span>}
                        <button className="login-submit-button" onClick={this.checkPasswordRequirements}>
                            confirm
                        </button>
                    </div>
                </div>
                <div className="login-logo">
                    <img src={logo} />
                </div>
                <div className="login-triangle">
                    <img src={background} />
                </div>
            </div>
        );
    }

    private passwordChanged = (event: ChangeEvent<HTMLInputElement>): void =>
        this.setState({
            password: event.currentTarget.value
        });

    private confirmPasswordChanged = (event: ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            confirmPassword: event.currentTarget.value
        });
    };

    private checkPasswordRequirements = (): void => {
        const passwordRequirementsMessage: string =
            "The password you entered doesn't meet the minimum security requirements. The password must contain at least 6 characters, 1 upper case and 1 digit.";
        const arePasswordsTheSame: boolean = this.state.password === this.state.confirmPassword && this.state.password.length > 0;
        const isPasswordCorrect = passwordRegex.test(this.state.password) && arePasswordsTheSame;
        if (!arePasswordsTheSame) {
            this.setState({ passwordErrorMessage: 'Passwords must be the same' });
        } else {
            this.setState({ passwordErrorMessage: passwordRequirementsMessage });
        }
        if (isPasswordCorrect) {
            this.setState({ passwordErrorMessage: '' });
            this.changePasswordClicked();
        }
    };

    private changePasswordClicked = (): void => {
        this.props.dispatch(new UserChangePasswordRequested(this.state.password));
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    errorMessage: state.user.errorMessage
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangePassword);



// WEBPACK FOOTER //
// ./src/view/login/ChangePassword.tsx